
import {CREATE_PROJECT_ERROR} from "../../reducers/createProjectReducer";


export const createProjectError = (error) =>{
    return {
        type: CREATE_PROJECT_ERROR,
        payload: {error}
    }
}